export default {
  TYPES: {
    APPUSER: { type: 'APPUSER', name: 'Aplicativo' },
    COMPANY: { type: 'COMPANY', name: 'Vale-transporte' },
    SUPERVISOR: { type: 'SUPERVISOR', name: 'Supervisor' },
    EMPLOYEE: { type: 'EMPLOYEE', name: 'Supervisor' },
    SCHOOL: { type: 'SCHOOL', name: 'Instituições de Ensino' },
    TERMINAL: { type: 'TERMINAL', name: 'Redes de Venda' },
    POINT: { type: 'POINT', name: 'Ponto de Venda' },
    ATTENDANT: { type: 'ATTENDANT', name: 'Atendente' },
  },

  MODULES: {
    CALENDAR: {
      value: 'CALENDAR',
      name: 'Calendário',
      type: 'SUPERVISOR',
      includes: [],
    },
    USER: { value: 'USER', name: 'Clientes', type: 'SUPERVISOR', includes: [] },
    TOLL: { value: 'TOLL', name: 'Pedágios', type: 'SUPERVISOR', includes: [] },
    INTEGRATION_FENCE: {
      value: 'INTEGRATION_FENCE',
      name: 'Cercas',
      type: 'SUPERVISOR',
      includes: [],
    },
    GARAGE: {
      value: 'GARAGE',
      name: 'Garagens',
      type: 'SUPERVISOR',
      includes: [],
    },
    SECTION: {
      value: 'SECTION',
      name: 'Seções',
      type: 'SUPERVISOR',
      includes: [],
    },
    STOP: { value: 'STOP', name: 'Paradas', type: 'SUPERVISOR', includes: [] },
    PROFILE: {
      value: 'PROFILE',
      name: 'Perfis',
      type: 'SUPERVISOR',
      includes: [],
    },
    FARE: { value: 'FARE', name: 'Tarifas', type: 'SUPERVISOR', includes: [] },
    TEAM: { value: 'TEAM', name: 'Time', type: 'SUPERVISOR', includes: [] },
    CAR: { value: 'CAR', name: 'Frota', type: 'SUPERVISOR', includes: [] },
    LOT: { value: 'LOT', name: 'Lote', type: 'SUPERVISOR', includes: [] },
    DBD: { value: 'DBD', name: 'DBDs', type: 'SUPERVISOR', includes: [] },
    TURNSTILES: {
      value: 'TURNSTILES',
      name: 'Catracas',
      type: 'SUPERVISOR',
      includes: [],
    },
    EMPLOYEE: {
      value: 'EMPLOYEE',
      name: 'Equipe',
      type: 'SUPERVISOR',
      includes: [],
    },
    SYSTEM: {
      value: 'SYSTEM',
      name: 'Sistema',
      type: 'SUPERVISOR',
      includes: [],
    },
    TRANSPORT_CARD: {
      value: 'TRANSPORT_CARD',
      name: 'Cartões de Transporte',
      type: 'SUPERVISOR',
      includes: [],
    },
    LINE: { value: 'LINE', name: 'Linhas', type: 'SUPERVISOR', includes: [] },
    RULE: {
      value: 'RULE',
      name: 'Regras de Negócio',
      type: 'SUPERVISOR',
      includes: [],
    },
    FACIAL: {
      value: 'FACIAL',
      name: 'Reconhecimento Facial',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT: {
      value: 'REPORTS',
      name: 'Relatórios',
      type: 'SUPERVISOR',
      includes: [],
    },
    CONECTIVITY: {
      value: 'CONECTIVITY',
      name: 'Conectividade',
      type: 'SUPERVISOR',
      includes: [],
    },
    MONITORING: {
      value: 'MONITORING',
      name: 'Monitoramento',
      type: 'SUPERVISOR',
      includes: [],
    },
    ATTENDANCE: {
      value: 'ATTENDANCE',
      name: 'Atendimento',
      type: 'SUPERVISOR',
      includes: [
        'ATTENDANCE_CONVERSATION',
        'ATTENDANCE_CONFIGURATION',
        'ATTENDANCE_REPORT',
        'ATTENDANCE_REPLY',
        'ATTENDANCE_TAG',
        'ATTENDANCE_OFFICE_HOUR',
        'ATTENDANCE_ATTENDANT',
        'ATTENDANCE_RATING',
      ],
    },

    // SETTINGS
    SETTINGS: {
      value: 'SETTINGS',
      name: 'Gerenciamento',
      type: 'SUPERVISOR',
      includes: [],
    },

    // COMPANY
    COMPANY: {
      value: 'COMPANY',
      name: 'Empresas',
      type: 'SUPERVISOR',
      includes: [],
    },
    COMPANY_USER: {
      value: 'COMPANY_USER',
      name: 'Colaboradores',
      type: 'COMPANY',
      includes: [],
    },
    COMPANY_GROUP: {
      value: 'COMPANY_GROUP',
      name: 'Grupos de Empresa',
      type: 'COMPANY',
      includes: [],
    },
    COMPANY_ORDER: {
      value: 'COMPANY_ORDER',
      name: 'Pedidos',
      type: 'COMPANY',
      includes: [],
    },

    // SCHOOL
    SCHOOL: {
      value: 'SCHOOL',
      name: 'Instituições de Ensino',
      type: 'SUPERVISOR',
      includes: [],
    },
    SCHOOL_USER: {
      value: 'SCHOOL_USER',
      name: 'Alunos',
      type: 'SCHOOL',
      includes: [],
    },

    // ATTENDANCE
    CONVERSATION: {
      value: 'ATTENDANCE_CONVERSATION',
      name: 'Conversas',
      type: 'ATTENDANCE',
      includes: [],
    },
    CONFIGURATION: {
      value: 'ATTENDANCE_CONFIGURATION',
      name: 'Configurações de Atendimento',
      type: 'ATTENDANCE',
      includes: [],
    },
    ATTENDANCE_REPORT: {
      value: 'ATTENDANCE_REPORT',
      name: 'Relatórios de Atendimento',
      type: 'ATTENDANCE',
      includes: [],
    },
    REPLY: {
      value: 'ATTENDANCE_REPLY',
      name: 'Respostas Rápidas',
      type: 'ATTENDANCE',
      includes: [],
    },
    TAG: {
      value: 'ATTENDANCE_TAG',
      name: 'Tags',
      type: 'ATTENDANCE',
      includes: [],
    },
    OFFICE_HOUR: {
      value: 'ATTENDANCE_OFFICE_HOUR',
      name: 'Horário de Funcionamento',
      type: 'ATTENDANCE',
      includes: [],
    },
    ATTENDANT: {
      value: 'ATTENDANCE_ATTENDANT',
      name: 'Atendentes',
      type: 'ATTENDANCE',
      includes: [],
    },
    RATING: {
      value: 'ATTENDANCE_RATING',
      name: 'Avaliações',
      type: 'ATTENDANCE',
      includes: [],
    },

    // SELLING TERMINAL
    SELLING_TERMINAL: {
      value: 'SELLING_TERMINAL',
      name: 'Redes de Venda',
      type: 'SUPERVISOR',
      includes: [],
    },

    // Relacionamento
    NOTIFICATION: {
      value: 'NOTIFICATION',
      name: 'Notificação',
      type: 'SUPERVISOR',
      includes: [],
    },

    SEGMENTATION: {
      value: 'SEGMENTATION',
      name: 'Segmentação',
      type: 'SUPERVISOR',
      includes: [],
    },

    // TERMINAL (BLOCKS)
    TERMINAL: {
      value: 'TERMINAL',
      name: 'Terminais',
      type: 'SUPERVISOR',
      includes: [],
    },
  },

  // Reports Sub Modules
  SUB_MODULES: {
    REPORT_ENTRIES: {
      value: 'REPORT_ENTRIES',
      name: 'Entradas',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_STATION_EXIT: {
      value: 'REPORT_STATION_EXIT',
      name: 'Saídas',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_STATION_EXIT_QUANTITY: {
      value: 'REPORT_STATION_EXIT_QUANTITY',
      name: 'Saídas Agrupado',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_VALUE: {
      value: 'REPORT_VALUE',
      name: 'valor',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_LOCALIZATION: {
      value: 'REPORT_LOCALIZATION',
      name: 'Localização',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_RECEIPT: {
      value: 'REPORT_RECEIPT',
      name: 'Recebimento',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_ONBOARD_SALES: {
      value: 'REPORT_ONBOARD_SALES',
      name: 'Venda a Bordo',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_SALES_NETWORK: {
      value: 'REPORT_SALES_NETWORK',
      name: 'Rede de Venda',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_VT_AND_USERS: {
      value: 'REPORT_VT_AND_USERS',
      name: 'Vt e Usuários',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_PURCHASE: {
      value: 'REPORT_PURCHASE',
      name: 'Compras',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_IMPORTATIONS: {
      value: 'REPORT_IMPORTATIONS',
      name: 'Importações',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_BALANCE: {
      value: 'REPORT_BALANCE',
      name: 'Saldo',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_DEMAND_BY_LINE: {
      value: 'REPORT_DEMAND_BY_LINE',
      name: 'Demanda por Linha',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_DEMAND_BY_LINE_QUANTITY: {
      value: 'REPORT_DEMAND_BY_LINE_QUANTITY',
      name: 'Quantidade por Linha',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_DEMAND_BY_SEGMENT: {
      value: 'REPORT_DEMAND_BY_SEGMENT',
      name: 'Demanda por Trecho',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_DEMAND_BY_DAILY: {
      value: 'REPORT_DEMAND_BY_DAILY',
      name: 'Demanda por Dia',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_DEMAND_BY_CAR: {
      value: 'REPORT_DEMAND_BY_CAR',
      name: 'Demanda por Carro',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_HALF_TRIP: {
      value: 'REPORT_HALF_TRIP',
      name: 'Meia viagem',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_OPERATORS_COMMITTEE: {
      value: 'REPORT_OPERATORS_COMMITTEE',
      name: 'Comissão de Operadores',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_PASSENGERS_CARRIED: {
      value: 'REPORT_PASSENGERS_CARRIED',
      name: 'Relatório Passageiros Transportados',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_TRIPS_BY_LINE: {
      value: 'REPORT_TRIPS_BY_LINE',
      name: 'Viagens por Linha',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_SUPERIOR_ACCESS: {
      value: 'REPORT_SUPERIOR_ACCESS',
      name: 'Uso Superiores',
      type: 'SUPERVISOR',
      includes: [],
    },
    REPORT_PAYMENT_REQUEST: {
      value: 'REPORT_PAYMENT_REQUEST',
      name: 'Requisição Pagamento',
      type: 'SUPERVISOR',
      includes: [],
    },
  },

  // Modules Parametrisations
  MODULES_PARAMETRISATIONS: [
    {
      id: 'CLIENT',
      moduleName: 'Clientes',
      modules: [
        {
          key: '0',
          title: 'Permissão para cadastro de perfil',
          subTitle:
            'Parametriza para quais perfis este funcionário está habilitado a cadastrar perfis.',
        },
        {
          key: '14',
          title: 'Permissão para emissão de cartões',
          subTitle:
            'Parametriza para quais perfis este funcionário está habilitado a cadastrar cartões e/ou emitir novas vias de cartões.',
        },
      ],
    },
  ],

  // Modules Permitions
  MODULES_PERMITIONS: [
    { value: 'Editor', key: 'WRITE' },
    { value: 'Leitor', key: 'READ' },
    { value: 'Sem acesso', key: 'NO ACCESS' },
    { value: 'Variado', key: 'DIVERSE' },
  ],

  MODULES_PERMITIONS_NOT_ACCESS: [
    { value: 'Editor', key: 'WRITE' },
    { value: 'Leitor', key: 'READ' },
    { value: 'Variado', key: 'DIVERSE' },
  ],

  MODULES_PERMITIONS_NOT_DIVERSE: [
    { value: 'Editor', key: 'WRITE' },
    { value: 'Leitor', key: 'READ' },
  ],

  // Modules Manegement
  MODULOS_MANEGEMENT: [
    {
      value: 'Atendimento',
      key: 'ATTENDANCE',
      modules: [
        {
          key: '53',
          value: 'Conversas',
          oldKey: 'ATTENDANCE_CONVERSATION',
          path: '/atendimento',
        },
        {
          key: '54',
          value: 'Configurações',
          oldKey: 'ATTENDANCE_CONFIGURATION',
          path: '/atendimento/configuracoes',
        },
        {
          key: '55',
          value: 'Relatórios',
          oldKey: 'ATTENDANCE_REPORT',
          path: '/atendimento/relatorios',
        },
      ],
    },
    {
      value: 'Clientes',
      key: 'CLIENTS',
      modules: [
        {
          key: '0',
          value: 'Passageiros',
          oldKey: 'USER',
          path: '/bdos/passageiros',
        },
        {
          key: '1',
          value: 'Empresas',
          oldKey: 'COMPANY',
          path: '/bdos/empresas',
        },
        {
          key: '110',
          value: 'Veículos Cadastrados',
          oldKey: 'VEHICLE',
          path: '/bdos/empresas',
        },
        {
          key: '111',
          value: 'Histórico de Embarques',
          oldKey: 'REPORT_BOARDING_HISTORY',
          path: '/bdos/empresas',
        },
        {
          key: '2',
          value: 'Instituições de Ensino',
          oldKey: 'SCHOOL',
          path: '/bdos/instituicoes-de-ensino',
        },
      ],
    },
    {
      value: 'Validações',
      key: 'VALIDATIONS',
      modules: [
        {
          key: '3',
          value: 'Validação Cadastral',
          oldKey: 'FACIAL',
          path: '/bdos/validacao-cadastral',
        },
        {
          key: '4',
          value: 'Reconhecimento Facial',
          oldKey: 'FACIAL',
          path: '/bdos/reconhecimento-facial',
        },
        {
          key: '5',
          value: 'Liberação de Dispositivo',
          oldKey: 'FACIAL',
          path: '/bdos/liberacao-de-dispositivo',
        },
        {
          key: '5',
          value: 'Inspeção de Embarques',
          oldKey: 'BOARDING_INSPECTION',
          path: '/bdos/inspecao-de-embarques',
        },
      ],
    },
    {
      value: 'Frota',
      key: 'FLEET',
      modules: [
        { key: '8', value: 'Frota', oldKey: 'CAR', path: '/bdos/frota' },
        {
          key: '8',
          value: 'Embarcações',
          oldKey: 'SHIP',
          path: '/bdos/embarcacoes',
        },
      ],
    },
    // Gerenciamento
    {
      value: 'Gerenciamento',
      key: 'MANAGEMENT',
      modules: [
        {
          key: '9',
          value: 'Gerenciar Empresa',
          oldKey: 'COMPANY_MANAGEMENT',
          path: '/bdos/gerenciar-empresa',
        },
        {
          key: '72',
          value: 'Gerenciar Sistema',
          oldKey: 'SYSTEM_MANAGEMENT',
          path: '/bdos/gerenciar-sistema',
        },
        {
          key: '77',
          value: 'Gerenciar Pagamento ',
          oldKey: 'PAYMENT_CONFIG',
          path: '',
        },
        { key: '78', value: 'Impostos', oldKey: 'TAX', path: '' },
      ],
    },
    {
      value: 'Equipe',
      key: 'TEAM',
      modules: [
        {
          key: '10',
          value: 'Motoristas',
          oldKey: 'TEAM_DRIVERS',
          path: '/bdos/equipe/motoristas',
        },
        {
          key: '11',
          value: 'Cobradores',
          oldKey: 'TEAM_CHARGERS',
          path: '/bdos/equipe/cobradores',
        },
        {
          key: '12',
          value: 'Encarregados',
          oldKey: 'TEAM_IN_CHARGE',
          path: '/bdos/equipe/encarregados',
        },
        {
          key: '119',
          value: 'Gestão de máquinas',
          oldKey: 'TEAM_MACHINE_MANAGEMENT',
          path: '/bdos/equipe/gestao-de-maquinas',
        },
      ],
    },
    {
      value: 'Bilhetagem',
      key: 'TICKETING',
      modules: [
        { key: '13', value: 'DBDs', oldKey: 'DBD', path: '/bdos/dbds' },
        { key: '13', value: 'Central de Diagnóstico', oldKey: 'DBDMONITORING', path: '/bdos/dbds' },
        {
          key: '14',
          value: 'Cartões de Transporte',
          oldKey: 'TRANSPORT_CARD',
          path: '/bdos/cartoes-de-transporte',
        },
        {
          key: '15',
          value: 'Perfis',
          oldKey: 'PROFILE',
          path: '/bdos/bilhetagem/perfis',
        },
        { key: '16', value: 'Tarifas', oldKey: 'FARE', path: '/bdos/tarifas' },
        {
          key: '16',
          value: 'Alterações por Período',
          oldKey: 'RULE',
          path: '/bdos/alteracoes-por-periodo',
        },
        {
          key: '16',
          value: 'Taxas de Embarque',
          oldKey: 'RULE',
          path: '/bdos/taxas-de-embarque',
        },
        {
          key: '17',
          value: 'Políticas Tarifárias',
          oldKey: 'RULE',
          path: '/regras-de-negocios/politicas-tarifarias',
        },
        {
          key: '18',
          value: 'Integrações',
          oldKey: 'INTEGRATIONS',
          path: '/bdos/bilhetagem/integracoes',
        },
        {
          key: '61',
          value: 'Produtos',
          oldKey: 'PRODUCT',
          path: '/bdos/produtos',
        },
        {
          key: '70',
          value: 'Catracas',
          oldKey: 'TURNSTILES',
          path: '/bdos/catracas',
        },
        {
          key: '91',
          value: 'Gestão de Estações',
          oldKey: '',
          path: '/bdos/bilhetagem/gestao-de-estacoes',
        },
        {
          key: '109',
          value: 'Configuração de Terminais',
          oldKey: 'TERMINAL_CONFIG',
          path: '',
        },
        {
          key: '120',
          value: 'Materiais Impressos',
          oldKey: 'PRINT_MODEL',
          path: '/bdos/bilhetagem/materiais-impressos',
        },
      ],
    },
    {
      value: 'Operação',
      key: 'OPERATION',
      modules: [
        { key: '19', value: 'Linhas', oldKey: 'LINE', path: '/bdos/linhas' },
        {
          key: '20',
          value: 'Itinerários',
          oldKey: 'ITINERARY',
          path: '/bdos/itinerarios',
        },
        { key: '21', value: 'Paradas', oldKey: 'STOP', path: '/bdos/pontos' },
        { key: '22', value: 'Seções', oldKey: 'STOP', path: '/bdos/secoes' },
        {
          key: '23',
          value: 'Garagens',
          oldKey: 'GARAGE',
          path: '/bdos/gestao-de-garagens',
        },
        {
          key: '24',
          value: 'Terminais',
          oldKey: 'TERMINAL',
          path: '/bdos/gestao-de-terminais',
        },
        // { key: '24', value: 'Bloqueios', oldKey: 'TERMINAL' },
        {
          key: '25',
          value: 'Pedágios',
          oldKey: 'TOLL',
          path: '/bdos/pedagios',
        },
        {
          key: '76',
          value: 'Cercas',
          oldKey: 'INTEGRATION_FENCE',
          path: '/bdos/cercas-de-integracao',
        },
      ],
    },
    {
      value: 'Arrecadação',
      key: 'COLLECTION',
      modules: [
        {
          key: '28',
          value: 'Redes de Venda',
          oldKey: 'SELLING_TERMINAL',
          path: '/bdos/arrecadacao/redes-de-venda',
        },
        {
          key: '29',
          value: 'Venda a Bordo',
          oldKey: 'SELLING_TERMINAL',
          path: '/bdos/arrecadacao/vendas-a-bordo',
        },
        {
          key: '30',
          value: 'VT e Usuários',
          oldKey: 'SELLING_TERMINAL',
          path: '/bdos/arrecadacao/vale-transporte',
        },
        {
          key: '94',
          value: 'Notas Fiscais',
          oldKey: 'SELLING_TERMINAL',
          path: '/bdos/arrecadacao/notas-fiscais',
        },
      ],
    },
    {
      value: 'Monitoramento',
      key: 'MONITORING',
      modules: [
        {
          key: '27',
          value: 'Monitoramento',
          oldKey: 'MONITORING',
          path: '/bdos/monitoramento-ao-vivo',
        },
      ],
    },
    {
      REPORTS: true,
      value: 'Relatórios',
      key: 'REPORTS',
      modules: [
        {
          key: '37',
          value: 'Entradas',
          oldKey: 'REPORT_ENTRIES',
          path: '/bdos/relatorios/relatorio-de-entrada',
        },
        {
          key: '121',
          value: 'Saídas',
          oldKey: 'REPORT_STATION_EXIT',
          path: '/bdos/relatorios/relatorio-de-saida',
        },
        {
          key: '122',
          value: 'Saídas Agrupado',
          oldKey: 'REPORT_STATION_EXIT_QUANTITY',
          path: '/bdos/relatorios/relatorio-de-saida',
        },
        {
          key: '38',
          value: 'Valor',
          oldKey: 'REPORT_VALUE',
          path: '/bdos/relatorios/relatorio-de-valor',
        },
        {
          key: '39',
          value: 'Localização',
          oldKey: 'REPORT_LOCALIZATION',
          path: '/bdos/relatorios/relatorio-de-embarque',
        },
        {
          key: '40',
          value: 'Recebimento',
          oldKey: 'REPORT_RECEIPT',
          path: '/bdos/relatorios/relatorio-de-recebimentos',
        },
        {
          key: '41',
          value: 'Venda a Bordo',
          oldKey: 'REPORT_ONBOARD_SALES',
          path: '/bdos/relatorios/relatorio-de-venda-a-bordo',
        },
        {
          key: '42',
          value: 'Rede de Venda',
          oldKey: 'REPORT_SALES_NETWORK',
          path: '/bdos/relatorios/relatorio-de-arrecadacao',
        },
        {
          key: '43',
          value: 'VT e Usuários',
          oldKey: 'REPORT_VT_AND_USERS',
          path: '/bdos/relatorios/relatorio-de-arrecadacao-de-vale-transporte',
        },
        {
          key: '44',
          value: 'Compras',
          oldKey: 'REPORT_PURCHASE',
          path: '/bdos/relatorios/relatorio-de-compras-por-empresa',
        },
        {
          key: '45',
          value: 'Saldo',
          oldKey: 'REPORT_BALANCE',
          path: '/bdos/relatorios/relatorio-emtu',
        },
        {
          key: '46',
          value: 'Demanda por Linha',
          oldKey: 'REPORT_DEMAND_BY_LINE',
          path: '/bdos/relatorios/demanda-por-linha',
        },
        {
          key: '81',
          value: 'Quantidade por Linha',
          oldKey: 'REPORT_DEMAND_BY_LINE_QUANTITY',
          path: '/bdos/relatorios/quantidade-por-linha',
        },
        {
          key: '82',
          value: 'Quantidade por Carro',
          oldKey: 'REPORT_DEMAND_BY_CAR_QUANTITY',
          path: '/bdos/relatorios/relatorio-de-quantidade-por-carro',
        },
        {
          key: '85',
          value: 'Km por Dia',
          oldKey: 'REPORT_CAR_KM_BY_DAY',
          path: '/bdos/relatorios/relatorio-km-por-dia-por-carro',
        },
        {
          key: '47',
          value: 'Demanda por Carro',
          oldKey: 'REPORT_DEMAND_BY_CAR',
          path: '/bdos/relatorios/relatorio-de-demanda-por-carro',
        },
        {
          key: '48',
          value: 'Meia Viagem',
          oldKey: 'REPORT_HALF_TRIP',
          path: '/bdos/relatorios/diario-de-meia-viagem',
        },
        {
          key: '49',
          value: 'Comissão de Operadores',
          oldKey: 'REPORT_OPERATORS_COMMITTEE',
          path: '/bdos/relatorios/relatorio-de-comissao-de-operadores',
        },
        {
          key: '50',
          value: 'Passageiros Transportados',
          oldKey: 'REPORT_PASSENGERS_CARRIED',
          path: '/bdos/relatorios/relatorio-geral',
        },
        {
          key: '51',
          value: 'Viagens por Linha',
          oldKey: 'REPORT_TRIPS_BY_LINE',
          path: '/bdos/relatorios/viagems-por-linha',
        },
        {
          key: '65',
          value: 'Demanda por Dia',
          oldKey: 'REPORT_DEMAND_BY_DAILY',
          path: '/bdos/relatorios/demanda-por-dia',
        },
        {
          key: '83',
          value: 'Quantidade por Dia',
          oldKey: 'REPORT_DEMAND_BY_DAILY_QUANTITY',
          path: '/bdos/relatorios/quantidade-por-dia',
        },
        {
          key: '84',
          value: 'Quantidade por Trecho',
          oldKey: 'REPORT_DEMAND_SECTION_QUANTITY',
          path: '/bdos/relatorios/quantidade-por-trecho',
        },
        {
          key: '66',
          value: 'Importações VAN',
          oldKey: 'REPORT_IMPORTATIONS',
          path: '/bdos/relatorios/relatorio-de-importacoes',
        },
        {
          key: '71',
          value: 'Demanda por Trecho',
          oldKey: 'REPORT_DEMAND_SECTION',
          path: '/bdos/relatorios/demanda-por-trecho',
        },
        {
          key: '73',
          value: 'Uso Superiores',
          oldKey: 'REPORT_SUPERIOR_ACCESS',
          path: '/bdos/relatorios/relatorio-de-uso-superior',
        },
        {
          key: '74',
          value: 'Requisição Pagamento',
          oldKey: 'REPORT_PAYMENT_REQUEST',
          path: '/bdos/relatorios/relatorio-de-requisicao-pagamento',
        },
        {
          key: '75',
          value: 'Embarque por Linha',
          oldKey: 'REPORT_ENTRIES_BY_LINE',
          path: '/bdos/relatorios/relatorio-de-embarque-por-linha',
        },
        {
          key: '79',
          value: 'Passageiros Transportados',
          oldKey: 'REPORT_ENTRY_BY_MONTH',
          path: '/bdos/relatorios/relatorio-de-passageiros-transportados',
        },
        {
          key: '80',
          value: 'KM Rodados',
          oldKey: 'REPORT_KM_BY_MONTH',
          path: '/bdos/relatorios/relatorio-de-km-rodados',
        },
        {
          key: '86',
          value: 'Passageiros Transportados por Faixa Horária',
          oldKey: 'REPORT_ENTRY_BY_HOUR',
          path: '/bdos/relatorios/relatorio-de-passageiros-por-faixa-horária',
        },
        {
          key: '88',
          value: 'Passagens - Geral',
          oldKey: 'REPORT_ENTRIES_GENERAL',
          path: '',
        },
        {
          key: '89',
          value: 'Resumo de Viagens',
          oldKey: 'EMPLOYEE_TRIP_RESUME_REPORT',
          path: '/bdos/relatorios/relatorio-resumo-de-viagems',
        },
        {
          key: '90',
          value: 'Consolidação da Arrecadação',
          oldKey: 'REPORT_INCOMING_CONSOLIDATION',
          path: '/bdos/relatorios/relatorio-de-consolidacao-de-arrecadacao',
        },
        {
          key: '92',
          value: 'Coleta',
          oldKey: 'REPORT_TRIP_COLLECTION',
          path: '/bdos/relatorios/relatorio-de-captacao',
        },
        {
          key: '93',
          value: 'Relatório de Emv',
          oldKey: 'REPORT_EMV',
          path: '/bdos/relatorios/relatorio-de-emv',
        },
        {
          key: '95',
          value: 'Relatório de Passageiro por Origem',
          oldKey: 'REPORT_ENTRIES_BY_COLLECTION',
          path:
            '/bdos/relatorios/relatorio-de-passageiros-transportados-por-origem',
        },
        {
          key: '97',
          value: 'Relatório de Passageiros por Faixa Horária por Perfil',
          oldKey: 'REPORT_ENTRIES_BY_HOUR_BY_PROFILE',
          path:
            '/bdos/relatorios/relatorio-de-passageiros-por-faixa-horária-por-perfil',
        },
        {
          key: '98',
          value: 'Relatório de Créditos por colégio',
          oldKey: 'REPORT_CREDIT_PER_SCHOOL',
          path: '/bdos/relatorios/credito-por-coleta',
        },
        {
          key: '99',
          value: 'Relatório de Estatística de utilização',
          oldKey: 'REPORT_ENTRIES_BY_COLLECTION',
          path: '/bdos/relatorios/estatistica-de-utilizacao',
        },
        {
          key: '100',
          value: ' Relatórios de Operação • Perfil por Faixa Etária',
          oldKey: 'REPORT_ENTRIES_BY_HOUR_BY_PROFILE',
          path: '/bdos/relatorios/relatorio-de-perfil-por-faixa-etaria',
        },
        {
          key: '101',
          value: 'Passageiros e Veículos',
          oldKey: 'PASSENGERS_AND_VEHICLES',
          path: '/bdos/relatorios/relatorio-de-passageiros-e-veiculos',
        },
        {
          key: '102',
          value: 'Passageiros e Veículos por Viagem',
          oldKey: 'PASSENGERS_AND_VEHICLES_BY_TRIP',
          path:
            '/bdos/relatorios/relatorio-de-passageiros-e-veiculos-por-viagem',
        },
        {
          key: '103',
          value: 'Pedestres por Terminal',
          oldKey: 'PASSENGERS_BY_TERMINAL',
          path: '/bdos/relatorios/relatorio-de-passageiros-por-terminal',
        },
        {
          key: '104',
          value: 'Consolidado de pedidos por Escola',
          oldKey: 'REPORT_ORDERS_BY_SCHOOL',
          path: '/bdos/relatorios/relatorio-consolidado-de-pedidos-por-escola',
        },
        {
          key: '105',
          value: 'Insepeção de Embarques por dia',
          oldKey: 'REPORT_FACIAL_DAILY_RESUME',
          path: '',
        },
        {
          key: '106',
          value: 'Inspeção de embarque detalhado do dia',
          oldKey: 'REPORT_FACIAL_DAY_DETAIL',
          path: '',
        },
        {
          key: '107',
          value: 'Rede de Vendas Acompanhamento de caixas em tempo real',
          oldKey: 'REPORT_SELLING_POINT_REAL_TIME',
          path: '',
        },
        {
          key: '112',
          value: 'Relatório de Estudantes e Mídias',
          oldKey: 'REPORT_STUDENTS_DEVICE',
          path: '/bdos/relatorios/relatorio-de-cartoes-por-aluno',
        },
        {
          key: '89',
          value: 'Relatório Resumido de Viagens de Motoristas',
          oldKey: 'EMPLOYEE_TRIP_SAP_RESUME_REPORT',
          path: '/bdos/relatorios/relatorio-resumido-de-viagens-de-motoristas',
        },
        {
          key: '108',
          value: 'Relatorios Exclusivos',
          oldKey: 'EXCLUSIVE_REPORTS_MODULE',
          path: '/bdos/relatorios-exclusivos',
          eternalReports: true,
        },
        {
          key: '113',
          value: 'Vinculações Pendentes',
          oldKey: 'REPORT_STUDENTS_PENDING ',
          path: '',
        },
        {
          key: '114',
          value: 'Bilhetagem eletrônica',
          oldKey: 'REPORT_BPE_AND_TRANSPORTED_PASSENGERS ',
          path: '/bdos/relatorios/bilhete-electronico',
        },
        {
          key: '115',
          value: 'Passageiros transportados x BP-e',
          oldKey: 'REPORT_BPE_TAX_VERIFICATION ',
          path: '/bdos/relatorios/bilhete-electronico-verificacao-do-icms',
        },
        {
          key: '116',
          value: 'Gratuidades',
          oldKey: 'FREE_ENTRY_REPORT',
          path: '/bdos/relatorios/relatorio-gratuidades',
        },
        {
          key: '118',
          value: 'Relatório de entradas com timeout',
          oldKey: 'REPORT_TIMED_OUT_ENTRIES',
          path: '',
        },
      ],
    },

    {
      value: 'Relacionamento',
      key: 'RELATIONSHIP',
      modules: [
        {
          key: '6',
          value: 'Notificações',
          oldKey: 'NOTIFICATION',
          path: '/bdos/relacionamento/notificacoes',
        },
        {
          key: '7',
          value: 'Segmentações',
          oldKey: 'SEGMENTATION',
          path: '/bdos/relacionamento/segmentacoes',
        },
      ],
    },
    {
      value: 'Programação',
      key: 'SCHEDULE',
      modules: [
        { key: '26', value: 'Programação', oldKey: 'SCHEDULING', path: '' },
      ],
    },
    {
      value: 'Analytics',
      key: 'ANALYTICS',
      modules: [
        { key: '31', value: 'Analytics', oldKey: 'ANALYTICS', path: '' },
      ],
    },

    {
      value: 'Ajustes',
      key: 'SETTINGS',
      modules: [
        {
          key: '32',
          value: 'Ajustes',
          oldKey: 'SYSTEM',
          path: '/bdos/ajustes',
        },
      ],
    },

    {
      value: 'Faturas',
      key: 'INVOICES',
      modules: [
        {
          key: '33',
          value: 'Faturas',
          oldKey: 'BILLING',
          path: '/bdos/faturas',
        },
      ],
    },

    {
      value: 'Ocorrências',
      key: 'OCCURRENCES',
      modules: [
        { key: '34', value: 'Ocorrências', oldKey: 'OCCURRENCES', path: '' },
      ],
    },
    {
      value: 'Conectividade',
      key: 'CONECTIVITY',
      modules: [
        {
          key: '68',
          value: 'Plano de Dados',
          oldKey: 'LINE',
          path: '/bdos/conectividade/plano-de-dados',
        },
        // Leftover from when this was a separate submodule alongside Plano de
        // Dados; the two were merged into one flow and this entry was missed
        // during that cleanup. To revert, uncomment and restore the separate
        // drawer entry too (see components/Drawer/index.tsx).
        // {
        //   key: '68',
        //   value: 'Planos de Dados',
        //   oldKey: 'ITINERARY',
        //   path: '/bdos/conectividade/chips-onboard',
        // },
        {
          key: '68',
          value: 'Cobertura de Conexão',
          oldKey: 'ITINERARY',
          path: '/bdos/conectividade/cobertura-de-conexao',
        },
      ],
    },
    {
      value: 'Pagamento Externo',
      key: 'EXTERNAL_PAYMENT',
      modules: [
        {
          key: '87',
          value: 'Pagamento Externo',
          oldKey: 'EXTERNAL_PAYMENT',
          path: '',
        },
      ],
    },
  ],

  // FIREBASE FORBIDDEN INTERNAL CODE LABEL
  FIREBASE_FORBIDDEN: 'firebaseauthentication.checkfirebaseauth.forbidden',
};
